import './ViewportOverlay.scss'

import React from 'react'

export interface ViewportOverlayProps {
  children?: React.ReactNode
  onClick?: () => void
}

export default function ViewportOverlay({ children, onClick }: ViewportOverlayProps): JSX.Element {
  return (
    <>
      <div className="ViewportOverlay" onClick={onClick}></div>
      {children}
    </>
  )
}
